import React, { useState } from 'react';
import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Sidebar from '../common/sidebar/index'
import { BarChart } from './Barchart';
import { PieChart } from './piechart';
import { Sectors } from './Sectors';
import { Categorysales } from './Categorysales';
import { TopSellProducts } from './Topsellingproducts';
import { TopSellingPromoProducts } from './Topsellingpromoproducts';
import { Loggedinnotordered } from './Loggedinnotordered';
import { TopCustomers } from './TopCustomers';
import { CustomerFirstOrders } from './CustomerFirstOrders';
import { Statistics } from './Statistics';
import { HourlyReport } from './HourlyReport';
import { Weeklyreport } from './Weeklyreport';
import { Abandonedcart } from './Abandonedcart';
import { Daywisereport } from './Daywisereport';
import { SectorMonthlyReport } from './SectorMonthlyReport';
import { TopRevenueChart } from './TopRevenuechart';
import { PriceBandReport } from './PriceBandReport';
import { DepotTopSellingProducts } from './DepotTopSellingProducts';
import { SectorChart } from './RevenueReport';
import { CustomerReport } from './CustomerReport';
import { DepotTopBottomSellingProducts } from './DepotTopBottomSellingProducts';
import { DepotBasedTopCustomers } from './DepotBasedTopCustomers';
import { DepotBasedRevenueReport } from './DepotBasedRevenueReport';
import { PromoOrders } from './PromoOrders';
import { SectorwiseTopsellingproducts } from './SectorwiseTopsellingproducts';
import { SectorBasedAverageproductSoldChart } from './sectorbasedaveragesoldproducts';
import { CustomerLifeTimeValue } from './CustomerLifeTimeValue';
import { EmailReport } from './EmailReport';
import { EmailEffectivenessReport } from './EmailEffectivenessReport';
import { SectorBasedHourlyReport } from './SectorBasedHourlyReport';
import { CustomerWisefavouritedReport } from "./Customerwisefavouritedreport";
import { ProductWisefavouritedReport } from "./Productwisefavouritedreport";
import { OrderWisefavouritedReport } from "./Orderwisefavouritedreport";

const Dashboard = () => {
  const tabs = ['Revenue & Order Report', 'Customer Report', 'Product Report', 'Promo Report', 'Sector Report', 'Price Band Report', 'Depot Based Report','Email Report'];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    //sessionStorage.setItem('dashboardActiveTab', tab);
  };

  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">Dashboard</h1>
            <div className="text-note" style={{ fontSize: '14px' }}>
              Note: When you choose a specific time like Past 1 Day, 7 Days, 30 Days, 90 Days, 180 Days, 1 Year or any custom date range, the system will display data from the current time up until the same time on the last day of the selected period.
            </div>
            <br />

            {/* Stats Section */}
            <div className="right-table-outer-wrap">
              <div className="flex-container">
                <Statistics />
              </div>
            </div>
            {/* Tabs */}
            <div className="right-table-outer-wrap">
              <div className="flex-container">
                <div className="header-tab-menu">
                  {tabs.map((tab) => (
                    <a
                      key={tab} // 🔥 Prevents DOM reconciliation issues
                      className={activeTab === tab ? 'active' : ''}
                      onClick={() => handleTabChange(tab)}
                    >
                      {tab}
                    </a>
                  ))}
                </div>

                {/* Tab Content */}
                <div className="tab-content">
                  {/* Revenue and  Order Reports */}
                  {activeTab === 'Revenue & Order Report' && (
                    <div key="order" className="tab-pane">
                      <div className="flex-container">
                        <div className="flex-left full-width revenue-chart-wrap">
                          <BarChart />
                        </div>
                        <div className="flex-right orders-chart-wrap">
                          <PieChart />
                        </div>
                        <div className="flex-left flex-w-66 customers-chart-wrap">
                          <Daywisereport />
                        </div>
                        <div className="flex-left sector-chart-wrap">
                          <Weeklyreport />
                        </div>
                        <div className="flex-left sector-chart-wrap">
                          <TopRevenueChart />
                        </div>
                        <div className="flex-left full-width customers-chart-wrap">
                          <HourlyReport />
                        </div>
                        <div className="flex-left sector-chart-wrap">
                          <SectorMonthlyReport />
                        </div>
                        <div className="flex-left sector-chart-wrap">
                          <OrderWisefavouritedReport />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Customer Reports */}
                  {activeTab === 'Customer Report' && (
                    <div key="customer" className="tab-pane">
                    <div className="flex-container">
                        <div className="flex-left full-width customers-chart-wrap">
                          <Abandonedcart />
                        </div>
                        <div className="flex-left full-width products-customers-chart-wrap">
                          <CustomerReport />
                        </div>
                        <div className="flex-left full-width hiVal-customers-chart-wrap">
                          <CustomerFirstOrders />
                        </div>
                        <div className="flex-left full-width hiVal-customers-chart-wrap">
                          <DepotBasedTopCustomers />
                        </div>
                        <div className="flex-left full-width customers-chart-wrap">
                          <Loggedinnotordered />
                        </div>
                        <div className="flex-left full-width products-chart-wrap">
                          <CustomerLifeTimeValue />
                        </div>
                        <div className="flex-left full-width products-chart-wrap">
                          <CustomerWisefavouritedReport />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Product Reports */}
                  {activeTab === 'Product Report' && (
                    <div key="product" className="tab-pane">
                      <div className="flex-container">
                        <div className="flex-left full-width products-chart-wrap">
                          <TopSellProducts />
                        </div>
                        <div className="flex-left flex-w-60 products-chart-wrap">
                          <ProductWisefavouritedReport />
                        </div>
                        <div className="flex-left flex-w-40 customers-chart-wrap">
                          <Categorysales />
                        </div>
                        <div className="flex-left full-width products-chart-wrap">
                          <DepotTopBottomSellingProducts />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Promo Reports */}
                  {activeTab === 'Promo Report' && (
                    <div key="promo" className="tab-pane">
                    <div className="flex-container">
                    <div className="flex-left full-width customers-chart-wrap">
                      <PromoOrders />
                    </div> 
                    <div className="flex-left full-width customers-chart-wrap">
                        <SectorBasedHourlyReport />
                      </div>
                      <div className="flex-left flex-leftflex-w-60 products-chart-wrap top-selling-promo-prod">
                        <TopSellingPromoProducts />
                      </div>
                      
                  </div>
                  </div>
                  )}

                  {/* Sector Reports */}
                  {activeTab === 'Sector Report' && (
                    <div key="sector" className="tab-pane">
                      <div className="flex-container">
                        <div className="flex-left sector-chart-wrap">
                          <Sectors />
                        </div>
                        <div className="flex-left sector-chart-wrap">
                          <SectorChart />
                        </div>
                        <div className="flex-left sector-chart-wrap">
                          <SectorwiseTopsellingproducts />
                        </div>
                        <div className="flex-left sector-chart-wrap">
                          <SectorBasedAverageproductSoldChart />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Price Band Reports */}
                  {activeTab === 'Price Band Report' && (
                    <div key="priceband" className="tab-pane">
                      <div className="flex-container">
                        <div className="flex-left full-width hiVal-price-chart-wrap">
                          <PriceBandReport />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Depot-Based Reports */}
                  {activeTab === 'Depot Based Report' && (
                    <div key="depot" className="tab-pane">
                      <div className="flex-container">
                        <div className="flex-left full-width depot-top-selling-prod">
                          <DepotTopSellingProducts />
                        </div>
                        <div className="flex-left full-width hiVal-customers-chart-wrap">
                          <DepotBasedRevenueReport />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Email Reports */}
                  {activeTab === 'Email Report' && (
                    <div key="email" className="tab-pane">
                      <div className="flex-container">
                        <div className="flex-left full-width hiVal-price-chart-wrap">
                          <EmailReport />
                        </div>
                        <div className="flex-left full-width hiVal-price-chart-wrap">
                          <EmailEffectivenessReport />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default Dashboard;